//import debounce from "../utils/debounce.js";
import initCustomScrollbar from "../modules/init-custom-scrollbar.js";

const initBlock = async function( block ) {
	const body = $( "body" );
	const menuToggler = block.find( "[data-menu-toggler]" );
	const menu = block.find( "[data-menu]" );
	const menuScrollWrapper = block.find( "[data-scroll-wrapper]" );

	await import( "../plugins/scrollbar.min.js" );

	class Menu {
		constructor() {
			this.$html = $( "html" );
			this.$body = $( "body" );
			this.$header = $( ".section-header" );
			this.init();
		}

		init() {
			if ( !this.$header.length ) {
				return;
			}

			this.$menu = this.$header.find( ".section-header__nav-list" );

			this.menuToggle();
		}

		menuToggle() {
			let $menuLink = this.$menu.find( ".menu-item-has-children> a" );
			let $subMenu = this.$menu.find( "> .menu-item-has-children > .sub-menu" );

			$subMenu.find( ".menu-item-has-children" ).on( "mouseenter", function() {
				if ( window.matchMedia( "(min-width: 1280px)" ).matches && $( this )[0].getBoundingClientRect().right > document.querySelector( ".wp-site-blocks" ).clientWidth - 250 ) {
					$( this ).children( ".sub-menu" ).addClass( "to-left" );
				} else {
					$( this ).children( ".sub-menu" ).removeClass( "to-left" );
				}
			} );

			$menuLink.on( "click", ( e ) => {
				if ( ( $( e.currentTarget ).attr( "href" ) === "#" ) || $( e.target ).hasClass( "dropdown-arrow" ) ) {
					e.preventDefault();

					if ( window.matchMedia( "(max-width: 1279px)" ).matches ) {
						$( e.currentTarget ).next( ".sub-menu" ).toggleClass( "active" ).slideToggle( 300 ).find( ".sub-menu" ).slideOut( 300 ).removeClass( "active" ).removeAttr( "style" );
					} else {
						$( e.currentTarget ).next( ".sub-menu" ).removeAttr( "style" ).removeClass( "active" ).find( ".sub-menu" ).removeAttr( "style" ).removeClass( "active" );
					}
				}
			} );

		}
	}

	new Menu();

	menuToggler.on( "click", function() {
		if ( menu.hasClass( "active" ) ) {
			hideMenu();
		} else {
			showMenu();
		}
	} );

	function hideMenu() {
		body.removeClass( "scroll-locked" );
		menuToggler.removeClass( "active" );
		menu.removeClass( "active" );
		block.removeClass( "menu-open" );
	}

	function showMenu() {
		body.addClass( "scroll-locked" );
		menuToggler.addClass( "active" );
		menu.addClass( "active" );
		block.addClass( "menu-open" );
	}

	$( window ).on( "scroll", () => {
		if ( $( window ).scrollTop() < 10 ) {
			block.removeClass( "menu-sticky" );
		} else {
			block.addClass( "menu-sticky" );
		}
	} );

	const menuNav = block.find( "[data-menu-nav]" ).clone( true, true );

	if ( !window.matchMedia( "(min-width: 1280px)" ).matches ) {
		initCustomScrollbar( block );
	}

	window.addEventListener( "resize", () => {
		if ( window.matchMedia( "(min-width: 1280px)" ).matches ) {
			let scrollOuter = $( "<div class=\"scrollbar-outer\"></div>" );
			menuNav.appendTo( scrollOuter );
			menuScrollWrapper.empty().append( scrollOuter );
			hideMenu();
		} else {
			initCustomScrollbar( block );
		}
	} );

};

themeUtils.loadBlock( initBlock, "header", ".section-header" );
